import angular from 'angular';
import { ThemesHelperService } from '../themesHelper';
import { FeatureCouponsService, FeatureCouponsServiceModule } from './coupons/coupons.service';
import { FeatureCustomersService, FeatureCustomersServiceModule } from './customers/customers.service';
import { FeatureObjectLockService, FeatureObjectLockServiceModule } from './objectLock/objectLock.service';

export class FeatureService {
  static $inject = [
    'FeatureObjectLockService',
    'FeatureCustomersService',
    'FeatureCouponsService',
    'ThemesHelperService',
  ];

  constructor(
    public objectLock: FeatureObjectLockService,
    public customers: FeatureCustomersService,
    public coupons: FeatureCouponsService,
    private themesHelperService: ThemesHelperService,
  ) {
    this.objectLock.init();
  }

  isEnabled(feature: { name: string; key?: string }) {
    if (feature.name && feature.key) {
      return this.themesHelperService.getFeaturesConfig(feature.name, feature.key);
    }

    return false;
  }
}

export const FeatureServiceModule = angular
  .module('acme.common.service.feature', [
    FeatureObjectLockServiceModule,
    FeatureCustomersServiceModule,
    FeatureCouponsServiceModule,
    'acme.common.service.themesHelper',
  ])
  .service('FeatureService', FeatureService).name;
